import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PipeModule } from '../shared/pipes/pipe.module';
import { PTLSharedModule } from '../shared/shared.module';
import { EntityRenewalModule } from './entity-renewal/entity-renewal.module';
import { IndividualRenewalModule } from './individual-renewal/individual-renewal.module';

  @NgModule({
    imports: [EntityRenewalModule,IndividualRenewalModule , FormsModule, PipeModule, PTLSharedModule ],    
  })
  export class RenewalModule { }


// WEBPACK FOOTER //
// ./src/app/renewal/renewal.module.ts